// extracted by mini-css-extract-plugin
export default {"container":"CQ-z","darkBackground":"DQ-z","whiteBackground":"EQ-z","headerButton":"FQ-z","calloutHeading":"GQ-z","calloutSubHeading":"HQ-z"};